export default __webpack_public_path__ + "static/media/Graph_left.c5813521.svg";